import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TabViewModule } from 'primeng/tabview';
import { CreateButtonComponent } from '../create-button/create-button.component';
import { TabOption } from './tabs.model';

@Component({
  selector: 'ui-tabs',
  standalone: true,
  imports: [TabViewModule, ButtonModule, RippleModule, CreateButtonComponent],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent<T> {
  public readonly options = input.required<TabOption<T>[]>();
  public readonly activeTab = input.required<T>();
  public readonly buttonLabel = input<string>();

  public readonly tabChange = output<T>();
  public readonly buttonClicked = output<void>();

  protected readonly activeIndex = computed(() =>
    this.options().findIndex((option) => option.value === this.activeTab()),
  );
}
